import loadable from '@loadable/component';

export const UpfrontPrice = loadable(
  () => import(/* webpackChunkName: 'upfront-price' */ './UpfrontPrice'),
);
